				import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { DateTime } from 'luxon';
import { BaseService } from "../BaseService";
import { UrlService } from "../UrlService";

@Injectable()
export class PersonService {
	private url: string;

	constructor(
		private myBaseService: BaseService,
		private urlService: UrlService
	){
		this.url = urlService.getURL('Person');
	}
	
	loadAll() : Observable<TooBig4Car.Logic.Person[]> {
		return this.myBaseService.loadAll(this.url);
	}
	loadAllForCustomer(id: System.Guid): Observable<TooBig4Car.Logic.Person[]> {
		return this.myBaseService.loadAll(this.url + '/ForCustomer/' + (id || ''));
	}
	loadAllAccountUsers(): Observable<TooBig4Car.Logic.Person[]> {
		return this.myBaseService.loadAll(this.url + '/AccountUsers');
	}
	save(tempItem: TooBig4Car.Logic.ObjectBase) : Observable<TooBig4Car.Logic.Person> {
		return this.myBaseService.save(tempItem, this.url);
	}
	deleteItem(id: System.Guid): Observable<boolean> {
		return this.myBaseService.deleteItem(id, this.url);
	}
	getEdit(id: System.Guid, customerID: System.Guid): Observable<TooBig4Car.Logic.Person> {
		var qs = '';
		if (!this.myBaseService.configData.IsEmptyGuid(customerID)) {
			qs = "?customerID=" + customerID;
		}
		return this.myBaseService.getWithParams(id, this.url+'/Edit', qs, false);
	}
	get(id: System.Guid) : Observable<TooBig4Car.Logic.Person>{
		return this.myBaseService.get(id, this.url);
	}
	sendResetPassword(id: System.Guid): Observable<string> {
		return this.myBaseService.post(null, this.url + '/ResetPassword/' + (id || ''), false);
	}
	sendEmailWelcome(id: System.Guid): Observable<string> {
		return this.myBaseService.post(null, this.url + '/EmailWelcome/' + (id || ''), false);
	}
	sendEmailDriverAdded(id: System.Guid): Observable<string> {
		return this.myBaseService.post(null, this.url + '/EmailDriverAdded/' + (id || ''), false);
	}
	driverExpirations(person: TooBig4Car.Logic.Person): { name: string, date: DateTime }[] {
		var col = [
			{ name: 'License Expiration Date', value: person.DriversLicenseExpiration },
			{ name: 'Medical Card Expiration Date', value: person.MedicalCardExpiration },
			{ name: 'Background Check Expiration Date', value: person.BackgroundCheckExpiration }
		];
		if (person.IsContractedDriver) {
			col.push({ name: 'Insurance Expiration Date', value: person.InsuranceExpiration });
		}
		return col.filter(a => a.value).map(a => {
			var date = DateTime.fromISO(a.value.toString());
			if (a.value.toString().endsWith('Z')) {
				date = date.toUTC();
			}
			return { name: a.name, date: DateTime.local(date.year, date.month, date.day) };
		});
	}


	addSupportMode(customerID: System.Guid): Observable<string> {
		return this.myBaseService.post(null, this.url + '/AddSupportMode/' + (customerID || ''), false);
	}
	removeSupportMode(): Observable<string> {
		return this.myBaseService.post(null, this.url + '/RemoveSupportMode', false);
	}
}		
